// Module I/O interchange
import Carousel from '../../modules/Carousel'
import Toggle from '../../modules/Toggle'

export default {
  Carousel,
  Toggle
}



// WEBPACK FOOTER //
// ./js/partner-site/modules/index.js